import config from "../../config";
import {CustomerServiceError} from "./error";
import {OptInState, Session} from "./customer";

export async function resetPassword(email:string): Promise<boolean> {
  const result = await fetch(`${config.customerServiceUrl}/customer/reset-password`, {
    body: JSON.stringify({email: email}),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
    },
    method: 'POST',
  });

  if (!result.ok) {
    const json = await result.json();
    throw new CustomerServiceError(json);
  }

  return true;
}

export async function verifyToken(token:string): Promise<string> {
  const result = await fetch(`${config.customerServiceUrl}/customer/verify-token/${token}`, {
    cache: 'no-cache',
    method: 'POST',
  });

  if (!result.ok) {
    const json = await result.json();
    throw new CustomerServiceError(json);
  }

  const json = await result.json();
  return json.email;
}

export async function setPassword(newPassword:string, token:string): Promise<boolean> {
  const result = await fetch(`${config.customerServiceUrl}/customer/set-password/${token}`, {
    body: JSON.stringify({newPassword: newPassword}),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
    },
    method: 'POST',
  });

  if (!result.ok) {
    const json = await result.json();
    throw new CustomerServiceError(json);
  }

  return true;
}

export async function changePassword(oldPassword:string, newPassword:string, session:Session): Promise<boolean> {
  const result = await fetch(`${config.customerServiceUrl}/customer/${session.customerId}/change-password`, {
    body: JSON.stringify({oldPassword: oldPassword, newPassword: newPassword}),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
      'NY-SESSION-TOKEN': `${session.token}`,
    },
    method: 'POST',
  });

  if (!result.ok) {
    const json = await result.json();
    throw new CustomerServiceError(json);
  }

  return true;
}
